import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { formatDistance } from 'date-fns';
import { MedicineService } from 'src/core/services/medicine.service';
import { DosageUnit, MedicineDosagePackageType, PackageType } from 'src/interfaces/medicine';

@Component({
  selector: 'core-medicine-dosage-package-type-list',
  templateUrl: './medicine-dosage-package-type-list.component.html',
  styleUrls: ['./medicine-dosage-package-type-list.component.scss']
})
export class MedicineDosagePackageTypeListComponent implements OnInit {

  displayedColumns: string[] = [
    'label_name',
    'type',
    'quantity',
    'price',
    'created',
    'actions'
  ]

  @Input() medicineDosagePackageTypes: MedicineDosagePackageType[];
  @Input() medicineId: number;
  @Input() medicineDosageTypeId: number;
  @Input() packageTypes: PackageType[];
  @Output() onUpdated = new EventEmitter<boolean>();
  @Input() dosageUnit: DosageUnit | null = null;

  // pagination state
  page: number = 1;
  limit: number = 10;
  total: number = 0;

  constructor(
    private _medicineService: MedicineService
  ) { }

  ngOnInit(): void {
    this.total = this._medicineService.getTotalNumberOfMedicineDosagePackageTypes();
  }

  async edit(medicineDosagePackageType: MedicineDosagePackageType) {
    const success: boolean = await this._medicineService
      .openMedicineDosagePackageTypeEditDialog(
        "Edit package type",
        "Edit package type",
        this.medicineId,
        this.medicineDosageTypeId,
        this.packageTypes,
        medicineDosagePackageType
      );

    if (success)
      this.onUpdated.emit(success);

  }

  async delete(medicineDosagePackageType: MedicineDosagePackageType) {

    const success: boolean = await this._medicineService
      .deleteMedicineDosagePackageType(
        this.medicineId,
        this.medicineDosageTypeId,
        medicineDosagePackageType.id);

    if (success)
      this.medicineDosagePackageTypes = this.medicineDosagePackageTypes.filter(_medicineDosagePackageType => _medicineDosagePackageType.id !== medicineDosagePackageType.id);

  }

  getCreationTime(medicineDosagePackageType: MedicineDosagePackageType) {
    return formatDistance(new Date(medicineDosagePackageType.created_at), new Date(), { addSuffix: true });
  }

  async onPageChange(event: PageEvent) {
    this.page = event.pageIndex + 1;
    this.limit = event.pageSize;
    await this.loadPage(this.page, this.limit);
  }

  async prevPage() {
    if (this.page <= 1) return;
    this.page = this.page - 1;
    await this.loadPage(this.page, this.limit);
  }

  async nextPage() {
    const lastPage = this.total > 0 ? Math.ceil(this.total / this.limit) : 1;
    if (this.page >= lastPage) return;
    this.page = this.page + 1;
    await this.loadPage(this.page, this.limit);
  }

  private async loadPage(page: number, limit: number) {
    const results: MedicineDosagePackageType[] = await this._medicineService
      .getMedicineDosagePackageTypes(
        this.medicineId,
        this.medicineDosageTypeId,
        page,
        limit,
        ''
      );
    this.medicineDosagePackageTypes = results;
    this.total = this._medicineService.getTotalNumberOfMedicineDosagePackageTypes();
  }

}

// computed helpers
export interface MedicineDosagePackageTypeListComponent {
  readonly lastPage: number;
}

Object.defineProperty(MedicineDosagePackageTypeListComponent.prototype, 'lastPage', {
  get: function(this: MedicineDosagePackageTypeListComponent) {
    const total = (this as any).total as number;
    const limit = (this as any).limit as number;
    return total > 0 ? Math.ceil(total / limit) : 1;
  },
  enumerable: true,
  configurable: true
});
